import { paymentProcessingApiBaseUrl, payrollRunApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { PaymentsGateway } from './PaymentsGateway';
import type { PaymentBatchResponse, PaymentTransactionResponse, PayrollRunSummary } from './types';

export class HttpPaymentsGateway implements PaymentsGateway {
  private readonly request = createJsonClient(paymentProcessingApiBaseUrl);
  private readonly payrollRunRequest = createJsonClient(payrollRunApiBaseUrl);

  async listApprovedPayrollRuns(signal?: AbortSignal): Promise<PayrollRunSummary[]> {
    const runs = await this.payrollRunRequest<PayrollRunSummary[]>('/api/payroll-runs', undefined, signal);
    return runs.filter((r) => r.status === 'Approved');
  }

  listBatchesForRun(payrollRunId: string, signal?: AbortSignal): Promise<PaymentBatchResponse[]> {
    return this.request(`/api/payroll-runs/${payrollRunId}/payment-batches`, undefined, signal);
  }

  initiateBatch(payrollRunId: string): Promise<PaymentBatchResponse> {
    return this.request(`/api/payroll-runs/${payrollRunId}/payment-batches`, { method: 'POST' });
  }

  listTransactions(batchId: string, signal?: AbortSignal): Promise<PaymentTransactionResponse[]> {
    return this.request(`/api/payment-batches/${batchId}/transactions`, undefined, signal);
  }

  checkBatchStatus(id: string): Promise<PaymentBatchResponse> {
    return this.request(`/api/payment-batches/${id}/check-status`, { method: 'POST' });
  }
}
